import { coreReducer } from './coreReducer';

export function coreApp(state = {}, action = {}) {
    return {
        core: coreReducer(state.core, action)
    };
}

export default coreApp;
